const STORAGE_PREFIX = 'admin_candidate_checks_session_';

export const getAdminChecksSessionKey = userId => (userId ? `${STORAGE_PREFIX}${userId}` : null);

export const readAdminChecksSession = userId => {
  const key = getAdminChecksSessionKey(userId);
  if (!key || typeof window === 'undefined') return null;

  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.queryParams) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const writeAdminChecksSession = (userId, session) => {
  const key = getAdminChecksSessionKey(userId);
  if (!key || typeof window === 'undefined') return;

  try {
    window.sessionStorage.setItem(key, JSON.stringify(session));
  } catch {
    // Ignore quota / private mode failures
  }
};
